import React from "react";

// Styles
import "./AddSavedView.scss";

const AddSavedView = ({ showAddDropdown, setShowAddDropdown, saveView }) => {
  const [savedViewTitle, setSavedViewTitle] = React.useState("");

  React.useEffect(() => {
    setSavedViewTitle("")
  },[showAddDropdown])

  const isValidSavedViewTitle = () => {
    return savedViewTitle.trim().length > 0;
  };

  const handleAddClick = () => {
    setSavedViewTitle("");
    saveView({ title: savedViewTitle.trim() }, true);
  };

  return (
    <div className="add-saved-view">
      <div className="header">
        <span className="title">Add View</span>
      </div>
      <div className="body">
        <div className="form-groups">
          <div className="form-group">
            <label>
              <strong>Name</strong>
            </label>
            <input
              type="text"
              maxLength="50"
              value={savedViewTitle}
              onChange={(e) => setSavedViewTitle(e.target.value)}
              className={`form-control ${!isValidSavedViewTitle() ? "error-input" : ""}`}
            />
          </div>
        </div>
      </div>
      <div className="footer">
        <button
          type="button"
          className="btn-secondary"
          onClick={() => {
            setShowAddDropdown(false);
          }}
        >
          Cancel
        </button>
        <button type="button" className="btn-primary" onClick={handleAddClick} disabled={!isValidSavedViewTitle()}>
          Add
        </button>
      </div>
    </div>
  );
};

export default AddSavedView;
